(function () {
  'use strict';
  var revision = 0;

  window.refreshCartFinalSaleBadges = function () {
    var currentRevision = ++revision;
    if (!document.querySelectorAll('#dropdown-cart [data-cart-variant-id]').length) {
      return Promise.resolve();
    }
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    return fetch(root + 'cart?view=final-sale', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart badge lookup failed');
        return response.json();
      })
      .then(function (eligibility) {
        if (currentRevision !== revision) return;
        document.querySelectorAll('#dropdown-cart [data-cart-variant-id]').forEach(function (row) {
          row.querySelectorAll('.cart-final-sale-badge').forEach(function (badge) { badge.remove(); });
          if (eligibility[row.getAttribute('data-cart-variant-id')] !== true) return;
          var collateral = row.querySelector('.cart-collateral');
          if (!collateral) return;
          var badge = document.createElement('span');
          badge.className = 'cart-final-sale-badge';
          badge.textContent = 'Final Sale';
          collateral.insertAdjacentElement('beforebegin', badge);
        });
      })
      .catch(function () {});
  };
})();
